import {Button, Message, Slide} from '../../types'
import {BTN_TYPE} from 'src/constants'

export function splitMessages(text) {
  let messages = []
  let match
  let previousMatch = []

  // First capture group is message, second is ignored, third is delay
  const regex = new RegExp(/([^]+?)(?:::next-?(\d+)?::|$)/g)
  while ((match = regex.exec(text))) {
    messages.push(new Message({
      text: match[1],
      delay: previousMatch[2] || 0
    }))
    previousMatch = match
  }

  return messages
}

export function createButton(mButton) {
  let button = new Button()
  button.text = mButton.buttonText
  button.value = mButton.target
  switch (mButton.buttonType) {
    case 'url': button.type = BTN_TYPE.URL; break
    default: button.type = BTN_TYPE.PAYLOAD
  }
  return button
}

export function createQuickReply(mQuickReply) {
  let button = new Button()
  button.type = BTN_TYPE.PAYLOAD
  button.text = mQuickReply.title
  return button
}

export function createSlide(mCard) {
  let slide = new Slide()
  slide.title = mCard.cardTitle
  slide.subtitle = mCard.cardSubtitle
  slide.image = mCard.cardImage
  slide.image_link = mCard.cardLink
  slide.buttons = mCard.buttons.map(createButton)
  return slide
}



// WEBPACK FOOTER //
// ./src/App/services/adapters/motion/helpers.js